import { gql } from '__generated__';

export const LotteryAttributesFragment = gql(`
  fragment LotteryAttributes on Lottery {
    id
    title
    start_date
    end_date
    started
    ended
    confirmable
    deletable
    locked
    confirmation_mail_text
    selected_registration_numbers
    rejected_registration_numbers
    registrations_count
    pending_registrations_count
    confirmed_registrations_count
    ticket {
      id
      title
    }
    promotion {
      id
      title
    }
    time_slot {
      id
      start_date
      start_time
      multi_date
      title
    }
    translations {
      ...TranslationFields
    }
  }
`);

export default gql(`
  query GetLottery($project_id: ID!, $lottery_id: ID!) {
    project(id: $project_id) {
      id
      lottery(id: $lottery_id) {
        ...LotteryAttributes
      }
    }
  }
`);
